import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchReturnOrders,
  setModal,
} from "../../../Features/orderManagementSlice";
import { updateReturnOrderStatus } from "../../../lib/utils/apiCalls";
import { showToast } from "../../../Components/Toaster/Toaster";

function KebabMenu({ boxRef, item }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [visible, setVisible] = useState(false);

  const isStillPending = item.returnStatus === "PENDING";

  const orderKebabOpen = useSelector(
    (state) => state.orderManagement.orderKebab.kebabOpen
  );

  const handleView = () => {
    navigate(`${location.pathname}/return-order/${item.orderId}`);
  };

  const handleAcceptReturn = async () => {
    try {
      const payload = {
        returnStatus: "ACCEPTED",
      };

      const response = await updateReturnOrderStatus(item.orderId, payload);
      if (response?.status === 200) {
        showToast(
          response.data?.data?.message || "Return order rejected successfully ",
          "success"
        );
        dispatch(fetchReturnOrders());
      } else {
        showToast("Error in Updating Reject Return.", "error");
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        "Something went wrong. Please try again.";
      showToast(errorMessage, "error");
    }
  };

  const handleRejectReturn = () => {
    dispatch(setModal("rejectReturn"));
  };

  useEffect(() => {
    if (orderKebabOpen) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [orderKebabOpen]);

  return (
    <div
      ref={boxRef}
      className={`${
        visible ? "opacity-100 visible" : "opacity-0 invisible"
      } transition-all duration-150 ease-in-out bg-[#FFFFFF] absolute z-10 w-40 top-6 right-12 flex flex-col gap-0 shadow-[0px_0px_12px_0px_#0000003D] rounded-md overflow-hidden`}
    >
      <button
        onClick={handleView}
        className="w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]"
      >
        <p className="font-medium text-[14px] leading-5 text-[#121212]">View</p>
      </button>
      {isStillPending && (
        <>
          <button
            onClick={handleAcceptReturn}
            className="w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]"
          >
            <p className="font-medium text-[14px] leading-5 text-[#121212]">
              Accept Return
            </p>
          </button>

          <button
            onClick={handleRejectReturn}
            className="w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]"
          >
            <p className="font-medium text-[14px] leading-5 text-[#121212]">
              Reject Return
            </p>
          </button>
        </>
      )}
    </div>
  );
}

export default KebabMenu;
